// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Usuarios_AlterarSenhaUsuarioResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response Contract for /usuarios/alterarSenhaUsuario
 *
 * Returns success flag after changing user password.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Usuarios_AlterarSenhaUsuarioResponseDados = boolean;

export type Usuarios_AlterarSenhaUsuarioResponse = ApiResponse<Usuarios_AlterarSenhaUsuarioResponseDados>;

registerResponseContract('Usuarios_AlterarSenhaUsuarioResponse', {})
